import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

/**
 * INVENTORY-TRUST.1c — Sales Import retirement banner.
 *
 * Non-alarming, informational: sales are now recorded automatically via the
 * POS integration; manual uploads are disabled. History remains fully
 * viewable, so this is an info banner, not a warning.
 */
interface Props {
  /** When true (admin), soften the "disabled" wording — uploads are admin-only, not fully off. */
  isAdmin?: boolean;
  sx?: object;
}

const SalesImportDeprecationBanner: React.FC<Props> = ({ isAdmin, sx }) => (
  <Alert severity="info" sx={{ borderRadius: 2, ...sx }}>
    <AlertTitle sx={{ fontWeight: 700 }}>Manual sales imports are being retired</AlertTitle>
    Sales are now recorded automatically through the POS integration.{' '}
    {isAdmin
      ? 'Manual uploads are restricted to administrators and should only be used for exceptional recovery. Everything already imported stays fully viewable below.'
      : 'Manual uploads are disabled. Everything already imported stays fully viewable below.'}
  </Alert>
);

export default SalesImportDeprecationBanner;
